import { Injectable } from '@angular/core';
import { TenantId } from "@allbesmart/web-app-common";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { HTTP_ENDPOINTS } from "../external/http";
import { first, merge, Observable, of, switchMap } from "rxjs";
import { ConfigurationFileDetailsDto } from "../models/configuration-file-details/configuration-file-details-dto";
import { UpdateConfigurationFileDetailsDto } from "../models/configuration-file-details/update-configuration-file-details-dto";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationFileService {

  constructor(private http: HttpClient) {
  }

  public deleteConfigurationFile(tenantId: TenantId, configurationFileDetailsId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}/${configurationFileDetailsId}`)
      .pipe(first())
  }

  public createConfigurationFile(tenantId: TenantId, configurationFile: File, description?: string): Observable<ConfigurationFileDetailsDto> {
    const formData = new FormData();
    formData.append('file', configurationFile);

    return this.http.post<ConfigurationFileDetailsDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}`, formData)
      .pipe(first(), switchMap(configurationFileDetailsDto => {
        if (configurationFileDetailsDto.description !== description) {
          return this.updateConfigurationFileDetails(tenantId, configurationFileDetailsDto.id, {
            filename: configurationFileDetailsDto.filename, description: description
          });
        } else {
          return of(configurationFileDetailsDto);
        }
      }));
  }

  public updateConfigurationFile(tenantId: TenantId, configurationFileId: string, configurationFile: File, description?: string): Observable<ConfigurationFileDetailsDto> {
    const formData = new FormData();
    formData.append('file', configurationFile);

    return this.http
      .put<ConfigurationFileDetailsDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}/${configurationFileId}`, formData)
      .pipe(first(), switchMap(configurationFileDetailsDto => this.updateConfigurationFileDetails(tenantId, configurationFileDetailsDto.id, {
        filename: configurationFile.name, description: description,
      })));
  }

  private updateConfigurationFileDetails(tenantId: TenantId, configurationFileId: string, updateConfigurationFileDetailsDto: UpdateConfigurationFileDetailsDto): Observable<ConfigurationFileDetailsDto> {
    return this.http.put<ConfigurationFileDetailsDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}/${configurationFileId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_DETAILS}`, updateConfigurationFileDetailsDto)
      .pipe(first());
  }

  public getConfigurationFileDetails$(tenantId: TenantId): Observable<ConfigurationFileDetailsDto[]> {
    return this.http.get<ConfigurationFileDetailsDto[]>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}`)
      .pipe(first());
  }

  public getFileContend(tenantId: TenantId, configurationFileId: string): Observable<Blob> {
    return this.http.get(`${environment.apiBasePath}/${HTTP_ENDPOINTS.TENANTS_BASE_PATH}/${tenantId}/${HTTP_ENDPOINTS.CONFIGURATION_FILE_BASE_PATH}/${configurationFileId}`, {responseType: "blob"}).pipe(first());
  }
}
